'use client';

interface ToolbarProps {
  onToolSelect: (tool: 'select' | 'component' | 'database' | 'edge') => void;
  activeTool: string;
}

export default function Toolbar({ onToolSelect, activeTool }: ToolbarProps) {
  const tools = [
    { id: 'select', label: 'Select', icon: '🖐️' },
    { id: 'component', label: 'Component', icon: '🖥️' },
    { id: 'database', label: 'Database', icon: '🗄️' },
    { id: 'edge', label: 'Connect', icon: '🔗' },
  ];

  return (
    <div className="bg-surface p-2 rounded-lg flex items-center space-x-2">
      {tools.map((tool) => (
        <button
          key={tool.id}
          onClick={() => onToolSelect(tool.id as any)}
          className={`px-3 py-2 rounded-md text-sm flex items-center space-x-2 transition-colors ${
            activeTool === tool.id
              ? 'bg-accent text-accent-foreground font-semibold'
              : 'bg-background text-foreground hover:bg-background-dark'
          }`}
        >
          <span className="text-lg">{tool.icon}</span>
          <span>{tool.label}</span>
        </button>
      ))}
    </div>
  );
}
